module.exports = __webpack_public_path__ + "img/about-us-bg_960.aa570e35.png";